import {cx} from "@emotion/css";
import {ReactComponent as SvgMessage} from "assets/svg/message.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmMessageIcon: React.FC<IIconBase> = ({id, size = "lg", color = designColors.black, className}) => {
  return <SvgMessage id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
